import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../../locales/keys';

const useStyles = makeStyles((theme) => ({
  buttonNode: {
    fontSize: '13px',
  },
  baseButtonNode: {
    padding: '12px 15px',
    backgroundColor: theme.palette.custom.white,
    width: '100%',
  },
  appliedVoucherHeading: {
    margin: '24px 0px',
    fontSize: '18px',
  },
  appliedCoupon: {
    minHeight: '20px',
    padding: '19px',
    marginBottom: '20px',
    backgroundColor: '#f5f5f5',
    border: 'none',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 1px rgb(0 0 0 / 5%)',
  },
}));

const AppliedVoucherCode = ({
  removeAppliedVoucherCode,
  appliedCouponsText,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box mb={5}>
      <Typography className={classes.appliedVoucherHeading} variant="h4">
        {t(LocaleKeys.payment.orders.subscriptionItemApplyCouponHeaderLabel)}:
      </Typography>
      <Box className={classes.appliedCoupon}>{appliedCouponsText}</Box>
      <Button
        disableRipple
        disableFocusRipple
        size="small"
        className={classes.baseButtonNode}
        onClick={() => removeAppliedVoucherCode()}
      >
        <Typography className={classes.buttonNode}>
          {t(LocaleKeys.payment.orders.removeFromOrder)}
        </Typography>
      </Button>
    </Box>
  );
};

export default AppliedVoucherCode;
